import Swal from 'sweetalert2';

const theme = {
    confirmButtonColor: '#002C5F', // Primary Blue
    cancelButtonColor: '#64748B', // Slate
    color: '#0F172A', // Navy Text
    background: '#FFFFFF',
    customClass: {
        popup: 'premium-swal-popup',
        title: 'premium-swal-title',
        confirmButton: 'premium-swal-button',
    }
};

export const showSuccess = (title, text) => {
    return Swal.fire({
        ...theme,
        icon: 'success',
        title,
        text,
        timer: 3000,
        showConfirmButton: false,
        iconColor: '#D4AF37' // Golden for success icons
    });
};

export const showError = (title, text) => {
    return Swal.fire({
        ...theme,
        icon: 'error',
        title,
        text,
        iconColor: '#ef4444'
    });
};

export const showLoading = (title = 'Processing...') => {
    Swal.fire({
        title,
        html: `
            <div class="swal-custom-loader">
                <div class="custom-spinner">
                    <div class="ring ring-outer"></div>
                    <div class="ring ring-middle"></div>
                    <div class="ring ring-inner"></div>
                </div>
            </div>
        `,
        allowOutsideClick: false,
        showConfirmButton: false,
        didOpen: () => {
            // Loader is handled via CSS animations in index.css
        }
    });
};

export const closeLoading = () => {
    Swal.close();
};

export const showConfirm = (title, text, confirmButtonText = 'Yes, Proceed') => {
    return Swal.fire({
        ...theme,
        title,
        text,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText,
        cancelButtonText: 'Cancel',
        reverseButtons: true,
        iconColor: '#D4AF37'
    });
};

export default Swal;
